import React, {
  useReducer,
  useRef,
  useState,
  useEffect,
  useContext,
} from "react";
import {
  Card,
  Row,
  Col,
  Form,
  Button,
  Tabs,
  TabPane,
  Container,
} from "react-bootstrap";
import api from "../../services/api.js";
import { erxProps } from "../../shared/data";
import Accordion from "react-bootstrap/Accordion";
import moment from "moment";
import AccordionCustomButton, {
  AccordionCardHeader,
} from "../../shared/AccordionCustomButton";
import { getInitials, postMultiPartData, TooltipLink } from "../../Helper";
import PhotoAlbum from "../../shared/MyPhotoAlbum";
import "yet-another-react-lightbox/styles.css";
import ReactToPrint from "react-to-print";
import ErxPrintable from "./ErxPrintable";
import AdviceContainer from "./AdviceContainer";
import { Link, useParams } from "react-router-dom";
import { BpContext, AppContext } from "../../context/AppContext";
import Loading from "../../shared/Loading.js";
import ErxHeader from "./ErxHeader";
import "react-bootstrap-typeahead/css/Typeahead.css";
import { Lightbox } from "yet-another-react-lightbox";
import GoogleDocViewer from "../../shared/GoogleDocViewer";

function Erx() {
  let { patientId, doctorId } = useParams();

  const [setLoaderActive, toast] = useContext(AppContext);
  const patientDetailUrl =
    process.env.REACT_APP_API_ENDPOINT + `/patient/${patientId}/`;
  const doctorDetailUrl =
    process.env.REACT_APP_API_ENDPOINT + `/patient/doctor/?key=${doctorId}`;
  const newErxUrl = process.env.REACT_APP_API_ENDPOINT + `/patient/new-erx/`;

  const [adviceData, dispatchAdviceData] = useReducer(adviceDataReducer, {
    erxId: 0,
    file: "",
  });
  const [historyData, dispatchHistoryData] = useReducer(adviceDataReducer, {
    Symptoms: [
      {
        serviceId: 0,
        name: "Dr. Nikhil Goyal",
        group: "IP Consultation",
        rate: 50,
        detail: "bbbb",
        timestamp: 1689070205871,
        files: [],
        key: "1689070206",
        patientId: "patient1",
        patientName: "Ankit Awasthi",
        doctorId: "doctor1",
        doctorName: "Dr. Nikhil Goyal",
        bpId: "bp1",
        bnName: "Swastika Nursing Home",
        bpBrId: "bpbr1",
        bpBrName: "Agarpara",
        erxDate: "2023-07-11",
      },
      {
        serviceId: 3,
        name: "Critical Care Team",
        group: "IP Consultation",
        rate: 400,
        detail: "cccc",
        timestamp: 1689070128003,
        files: [],
        key: "1689070141",
        patientId: "patient1",
        patientName: "Ankit Awasthi",
        doctorId: "doctor1",
        doctorName: "Dr. Nikhil Goyal",
        bpId: "bp1",
        bnName: "Swastika Nursing Home",
        bpBrId: "bpbr1",
        bpBrName: "Agarpara",
        erxDate: "2023-07-11",
      },
    ],
    Diagnostic: [],
    Surgical_Procedure: [],
    Therapetic_Procedure: [],
    Medication: [],
    Allergy: [],
    Diet_and_Nutrition: [],
  });

  //State Variables
  const [isLoading, setIsLoading] = useState(true);
  const [visibleAccordion, setVisibleAccordion] = useState("0");
  const [activeHistoryTab, setActiveHistoryTab] = useState("tabular");
  const [gallery, setGallery] = useState([]);
  const [erxDate, setErxDate] = useState(moment().format("yyyy-MM-DD"));
  const [newErxImageLightBox, setNewErxImageLightBox] = useState(false);
  //Ref variables
  const dateRef = useRef(null);
  const newErxRef = useRef(null);
  const printErxRef = useRef(null);
  const patient = useRef({
    bpPatientId: "patient1",
    patientName: "Ankit Awasthi",
  });
  const doctor = useRef({
    bpdoctorId: "doctor1",
    doctorName: "Dr. Nikhil Goyal",
  });

  const bp = useContext(BpContext);

  function adviceDataReducer(adviceData, action) {
    // console.log(adviceData, action);
    switch (action.type) {
      case "init": {
        return { ...adviceData, [action.key]: [] };
      }
      case "reset": {
        return {
          erxId: 0,
          file: "",
        };
      }
      case "put": {
        return { ...adviceData, ...action.data };
      }
      case "add": {
        const newData = [...adviceData[action.key], action.data].sort(
          (a, b) => {
            if (a.erxDate < b.erxDate) return 1;
            else if (a.erxDate > b.erxDate) return -1;

            if (a.timestamp < b.timestamp) return 1;
            else return -1;
          }
        );
        return { ...adviceData, [action.key]: newData };
      }
      case "update": {
        let advices = adviceData[action.key].filter(
          (s) => s.timestamp !== action.timestamp
        );
        const newData = [...advices, action.data].sort((a, b) => {
          if (a.erxDate < b.erxDate) return 1;
          else if (a.erxDate > b.erxDate) return -1;

          if (a.timestamp < b.timestamp) return 1;
          else return -1;
        });
        return { ...adviceData, [action.key]: newData };
      }
      default: {
        return adviceData;
      }
    }
  }
  const fetchGallery = async () => {
    try {
      // const response = await fetch("https://picsum.photos/v2/list");
      // const data = await response.json();
      let data = [];
      for (let index = 0; index < 30; index++) {
        data[index] = {
          id: index,
          title: "Alejandro Escamilla",
          src: `https://picsum.photos/id/${index}/200.jpg`,
          width: 200,
          height: 200,
        };
      }
      setGallery(data);
    } catch (error) {
      console.error("error", error);
    }
  };
  const startNewErx = async () => {
    try {
      setLoaderActive(true);
      const fileInput = document.getElementById("new-erx-file-input");
      const formData = new FormData();
      fileInput.files[0] && formData.append("files", fileInput.files[0]);
      formData.append("date", erxDate);
      formData.append("erxId", adviceData.erxId);
      const response = await api
        .post(newErxUrl, formData, {
          headers: { "Content-Type": "multipart/form-data" },
        })
        .then((res) => res.data);
      console.log(response);
      if (response.success) {
        dispatchAdviceData({ type: "put", data: response.response });
        // setLoaderActive(false);
      } else {
        console.log(response);

        setIsLoading("error");
      }
    } catch (ex) {
      toast.error("Something went wrong!");
    } finally {
      setLoaderActive(false);
    }
  };
  const toggleTab = async (k) => {
    if (k === "gallery") {
      await fetchGallery();
    }
    setActiveHistoryTab(k);
  };
  function handleAccordion(eventKey) {
    setVisibleAccordion(eventKey);
  }

  useEffect(() => {
    const fetchInitialData = async () => {
      // setLoaderActive(true);
      try {
        // setLoaderActive(true);

        const response1 = await api.get(patientDetailUrl);
        patient.current = await response1.data.response;
        console.log(patient.current);
        const responseDoctor = await api.get(doctorDetailUrl);
        doctor.current = await responseDoctor.data;
        setIsLoading(false);
        // setLoaderActive(false);
      } catch (error) {
        // setLoaderActive(false);
        setIsLoading("error");
        console.error("Error fetching data:", error);
        toast.error("Something went wrong! Try Again!");
      }
    };
    fetchInitialData();
  }, []);

  const handleScroll = (id) => {
    if (visibleAccordion === "") return false;
    if (visibleAccordion === "0") {
      id = id + "History";
      if (activeHistoryTab === "gallery") setActiveHistoryTab("tabular");
    }
    document.getElementById(id).scrollIntoView({ behavior: "smooth" });
  };
  if (isLoading === true) {
    return <Loading />;
  } else if (isLoading === "error") {
    return <Loading failed={true} />;
  }

  return (
    <Container className="erx-container">
      <Accordion defaultActiveKey={adviceData.erxId === 0 ? "0" : "1"} flush>
        <ul className="sticky-ul-container d-print-none">
          <AccordionCustomButton
            eventKey="0"
            className="sticky-li text-black bg-history-deep"
            as={"li"}
            title="History"
            Link={TooltipLink}
          >
            HI
          </AccordionCustomButton>

          {visibleAccordion !== "" && (
            <>
              {erxProps.map((props, index) => {
                return (
                  <TooltipLink
                    key={index}
                    title={props.adviceType}
                    id={props.id + "-tooltip"}
                  >
                    <Button
                      className={`sticky-li bg-${props.variant}`}
                      onClick={(e) => {
                        handleScroll(props.id);
                      }}
                      as="li"
                      variant="light"
                    >
                      {getInitials(props.adviceType)}
                      {/* <button className="btn  btn-link"></button> */}
                    </Button>
                  </TooltipLink>
                );
              })}
              <TooltipLink title={"Referels"} id={"referels-tooltip"}>
                <Button
                  className="sticky-li bg-success"
                  onClick={(e) => {
                    handleScroll("referels");
                  }}
                  as="li"
                  variant="light"
                >
                  RE
                </Button>
              </TooltipLink>
              <TooltipLink
                title={"Other Attachments"}
                id={"otherAttachments-tooltip"}
              >
                <Button
                  className="sticky-li bg-info"
                  onClick={(e) => {
                    handleScroll("otherAttachments");
                  }}
                  as="li"
                  variant="light"
                >
                  OA
                </Button>
              </TooltipLink>
            </>
          )}
          <TooltipLink title={"New eRx"} id={"newerx-tooltip"}>
            <AccordionCustomButton
              eventKey="1"
              className="sticky-li text-black bg-new-deep"
              as={"li"}
            >
              NE
            </AccordionCustomButton>
          </TooltipLink>
        </ul>
        <Row>
          <Col xs={12} sm={{ span: 4, offset: 4 }}>
            <h2 className="text-center">E-Prescription</h2>
          </Col>
          <Col sm={4} className="d-print-none">
            <Form.Group
              as={Row}
              className="my-3"
              controlId="formHorizontalEmail"
            >
              <Form.Label column xs={4} className="text-end">
                Date
              </Form.Label>
              <Col xs={8}>
                <Form.Control
                  type="date"
                  // defaultValue={moment().format("yyyy-MM-DD")}
                  ref={dateRef}
                  name="erxDate"
                  value={erxDate}
                  onChange={({ target }) => setErxDate(target.value)}
                />
              </Col>
            </Form.Group>
          </Col>
        </Row>
        <ErxHeader bp={bp} doctor={doctor.current} patient={patient.current} />

        <Card className="mb-3 bg-history d-print-none">
          <AccordionCardHeader eventKey="0" className="text-black">
            Patient History
          </AccordionCardHeader>
          <Accordion.Collapse
            eventKey="0"
            onEntering={(e) => handleAccordion("0")}
            onExit={() => setVisibleAccordion("")}
            className="patientHistory"
          >
            <Card.Body className="vh-75 overflow-auto scroll-history">
              <Tabs
                activeKey={activeHistoryTab}
                onSelect={(k) => toggleTab(k)}
                variant="tabs"
              >
                <TabPane eventKey={"tabular"} title="Tabular" variant="success">
                  <AdviceContainer
                    extraData={{
                      ...patient.current,
                      ...doctor.current,
                      ...bp,
                    }}
                    extraReferences={[dateRef]}
                    idSuffix={"History"}
                    newEntryForm={false}
                    adviceContext={historyData}
                    dispatchContext={dispatchHistoryData}
                  />
                </TabPane>
                <TabPane eventKey={"gallery"} title="Gallery">
                  <PhotoAlbum slides={gallery} />
                </TabPane>
              </Tabs>
            </Card.Body>
          </Accordion.Collapse>
        </Card>
        <Card className="mb-3 bg-new rounded-0">
          <AccordionCardHeader eventKey="1" className="text-black d-print-none">
            New eRx
          </AccordionCardHeader>
          <Accordion.Collapse
            eventKey="1"
            className="newErx"
            onEntering={(e) => handleAccordion("1")}
            onExit={() => setVisibleAccordion("")}
          >
            <>
              <Card.Body className="vh-75 overflow-auto scroll-new print-full rounded-0">
                <Form.Group className="mb-3">
                  <Form.Label className="transform-none">
                    Scanned copy of new <span>eRx</span> (optional)
                  </Form.Label>
                  <div className="input-group">
                    <input
                      type="file"
                      className="form-control"
                      id="new-erx-file-input"
                      aria-describedby="new-erx-file-input"
                      aria-label="Upload"
                      ref={newErxRef}
                    />
                    {adviceData.erxId === 0 && (
                      <button
                        className="btn btn-light bg-new-deep text-white border-secondary"
                        type="button"
                        id="new-erx-file-input-button"
                        onClick={startNewErx}
                      >
                        Start new eRx
                      </button>
                    )}
                    {adviceData.erxId !== 0 && (
                      <button
                        className="btn btn-secondary"
                        type="button"
                        id="new-erx-file-input-button"
                        onClick={startNewErx}
                      >
                        {adviceData.file === "" ? "Upload" : "Replace"}
                      </button>
                    )}
                  </div>
                  {adviceData.file && (
                    // && adviceData.file.file_ext !== ".pdf"
                    <>
                      <Lightbox
                        open={newErxImageLightBox}
                        close={() => setNewErxImageLightBox(false)}
                        slides={[
                          {
                            src:
                              process.env.REACT_APP_API_ENDPOINT +
                              "/file/" +
                              adviceData.file,
                          },
                        ]}
                      />
                      <div className="form-text" id="basic-addon4">
                        Upload another file to replace &nbsp;
                        <a
                          href="#"
                          onClick={(e) => {
                            e.preventDefault();
                            setNewErxImageLightBox(true);
                          }}
                        >
                          this
                        </a>
                      </div>
                    </>
                  )}
                  {adviceData.file && adviceData.file.file_ext === ".pdf" && (
                    <>
                      <GoogleDocViewer
                        show={newErxImageLightBox}
                        setShow={setNewErxImageLightBox}
                        fileURL={adviceData.file.server_path}
                        title={`eRx Id - ${adviceData.erxId}`}
                      />
                      <div className="form-text" id="basic-addon4">
                        Upload another file to replace &nbsp;
                        <a
                          href="#"
                          onClick={(e) => {
                            e.preventDefault();
                            setNewErxImageLightBox(true);
                          }}
                        >
                          this
                        </a>
                      </div>
                    </>
                  )}
                </Form.Group>
                {adviceData.erxId !== 0 && (
                  <>
                    <AdviceContainer
                      extraData={{
                        ...patient.current,
                        ...doctor.current,
                        ...bp,
                        erxId: adviceData.erxId,
                      }}
                      extraReferences={[dateRef]}
                      idSuffix={""}
                      newEntryForm={true}
                      adviceContext={adviceData}
                      dispatchContext={dispatchAdviceData}
                    />

                    <div className="d-none">
                      <ErxPrintable
                        ref={printErxRef}
                        bp={bp}
                        doctor={doctor.current}
                        patient={patient.current}
                        erxDate={erxDate}
                        erxId={adviceData.erxId}
                        adviceContainerProps={{
                          extraReferences: [dateRef],
                          idSuffix: "Print",
                          newEntryForm: false,
                          adviceContext: adviceData,
                          dispatchContext: dispatchAdviceData,
                        }}
                      />
                    </div>
                  </>
                )}
              </Card.Body>
              {adviceData.erxId !== 0 && (
                <Card.Footer className=" d-flex justify-content-between d-print-none">
                  <ReactToPrint
                    trigger={() => {
                      return (
                        <Button className="bg-new-deep" variant="light">
                          Print & Start New
                        </Button>
                      );
                    }}
                    onAfterPrint={() => dispatchAdviceData({ type: "reset" })}
                    content={() => printErxRef.current}
                  />
                  <ReactToPrint
                    trigger={() => {
                      return (
                        <Button className="bg-new-deep" variant="light">
                          Print
                        </Button>
                      );
                    }}
                    content={() => printErxRef.current}
                  />
                </Card.Footer>
              )}
            </>
          </Accordion.Collapse>
        </Card>
      </Accordion>
    </Container>
  );
}

export default Erx;
